import {
  VerifyAccountRequest,
  VerifyAccountResponse,
} from '@aaa-ncnu-ie/mypolicy-api-registrations';
import { useMutation } from '@tanstack/react-query';

import axios from '../../axios';

// This service is for checking if the user's email is already tied to an account.
export const verifyEmail = async (requestBody: VerifyAccountRequest) => {
  const { data } = await axios.post<VerifyAccountResponse>(
    `${import.meta.env.VITE_REGISTRATIONS_API_URL}/v1/verify-account`,
    requestBody
  );

  return data;
};

export const useEmailCheckMutation = () =>
  useMutation({
    mutationFn: (requestBody: VerifyAccountRequest) => verifyEmail(requestBody),
  });
